// 导入组件
// import mHeader from "./mHeader/index.js";
import dragButton from "./dragButton/index.js";
import swiper from "./swiper/index.js";

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，那么所有的组件都会被注册
const install = function(Vue) {
  // 判断是否安装
  if (install.installed) return;
  // 组件列表
  const components = [dragButton, swiper];
  // 遍历注册全局组件
  components.forEach(item => {
    if (item.install) {
      Vue.use(item);
    } else if (item.name) {
      Vue.component(item.name, item);
    }
  });
  install.installed = true;
};

// 判断是否是直接引入文件
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
  install
};
// 以下是具体的组件列表,按需引入
export { dragButton, swiper };



// WEBPACK FOOTER //
// ./src/packages/index.js